function getTopics(url,module){
    /*var settings = {
        "async": true,
        "crossDomain": true,
        "url": url,
        "method": "GET",
        "headers": {
            "cache-control": "no-cache",
        }
    }

    $.ajax(settings).done(function (response) {
        if(module=="joinconvo"){
            convoData(response);
        }
        else if(module=="photosFans"){
            photoData(response);
        }
    });*/
    if(module=="joinconvo"){
    var request = $.ajax({
        url: url,
        type: 'GET',
        data: { brand: $('#brandFilter').val().toLowerCase(),exclude:$('#excludeFilter').val(),time:$('#topicsTimefilter').val()},
        dataType: "json"        
      });
    
      request.done(function(data) {     
          convoData(data);  
      });
    }
    if(module=="photosFans"){
        var request = $.ajax({
            url: url,
            type: 'GET',
            data: { brand: $('#photosFilter').val().toLowerCase(),exclude:$('#albumFilter').val(),time:$('#albumTimefilter').val()},
            dataType: "json"        
          });
        
          request.done(function(data) {     
            photoData(data);  
          });
     }
      request.fail(function(jqXHR, textStatus) {
            console.log("API error");
      });
}
function photoData(data){
    
    let joinC = $(".photos-from-fans");
    var dataHtml = '';
    if(data.length > 0){
        dataHtml += "<ul>";
        let datalength = data.length==1 ? 1 : 2;
        for(let i=0; i < datalength; i++){
            dataHtml += "<li data-index='"+i+"'>";
            dataHtml += "<div class='item'>";
            //dataHtml += "<a class='desktop-image' target='_blank' href='"+data[i].url+"'><div class='photo-bg' style=background-repeat:no-repeat;background-image:url('"+data[i].images.large+"')></div></a>"
            dataHtml += "<a target='_blank' href='"+data[i].url+"'><img src='"+data[i].images.large+"' alt='"+data[i].images.alt+"'/></a>";
            dataHtml += "<div class='feed-info'>";
            dataHtml += "<p class='author-name'>Posted from User: "+data[i].author.name+"</p>";
          //  dataHtml += "<p class='album-name'>From Gallery Board: "+data[i].album+"</p>";
            dataHtml += "</div>";
            dataHtml += "</div>";
            dataHtml += "</li>"
        }        dataHtml += "</ul>";    }
    else{
        dataHtml += "<p class='no-data'>No data found</p>"
    }
    joinC.find('.photos-feed').html(dataHtml);
}
function convoData(data){
    let joinC = $(".join-convo-wrap");
    var dataHtml = '';
    var itemBG = joinC.attr('data-color');
    var itemBGi = joinC.attr('data-img');
    var styleC = '';
    if(itemBG && itemBG!=''){
        styleC = 'background-color:'+itemBG;
    }
    if(itemBGi.includes('assets/no-image-2048-') == false){
        styleC = 'background-image: url('+itemBGi+');background-size:cover';
    }
    if(data.length > 0){
        dataHtml += "<ul>";
        let datalength = data.length<=4 ? data.length : 4;
        for(let i=0; i < datalength; i++){
            dataHtml += "<li data-index='"+i+"'>";
            dataHtml += "<div class='item' style='"+styleC+"'>";
            dataHtml += "<div class='chat-heading'>";
            dataHtml += "<a href='"+data[i].url+"'>";
            dataHtml += "<h6 class='title h6'>"+data[i].title.slice(0, 50)+"</h2>";
            dataHtml += "</a>";
            dataHtml += "<a href='"+data[i].url+"'>";
            dataHtml += "<p class='authorD'><span class='chatF medium'>Chat From:</span> <span class='chatFv medium'>"+data[i].firstPost.author.name.slice(0, 50)+"</span></p>";
            dataHtml += "</a>";
            dataHtml += "</div>";
            dataHtml += "<div class='chat-footer'>";
            dataHtml += "<a href='"+data[i].url+"' class='chatLink'>";
            dataHtml += "<span class='chatIcon'><img src='https://cdn.shopify.com/s/files/1/0558/1599/5582/files/speech-bubble.png?v=1628150247' alt='Speech bubble icon'></span> <span class='medium'>"+data[i].posts+" replies</span>"
            dataHtml += "</a>";
            dataHtml += "</div>";
            dataHtml += "</div>";
            dataHtml += "</li>"
        }
        dataHtml += "</ul>";
    }    else{
        dataHtml += "<p class='no-data'>No Data Is Available</p>"
    }
    joinC.find('.convo-item-wrap').html(dataHtml);
}

$(document).ready(function(){
    let joinC = $(".join-convo-wrap");
    let photosFans=$(".photos-from-fans");
    if(joinC.length > 0){
        getTopics("https://services-community.creations.mattel.com/api/mattelapi/popular/topics","joinconvo");
    }   
    if(photosFans.length > 0){
        getTopics("https://services-community.creations.mattel.com/api/mattelapi/popular/images","photosFans");
    }  
})